import React, {useEffect, useState} from 'react';
import "../assets/css/Footer.css"
import "../assets/css/Buttons.css"
import "../assets/css/OpsLibrary.css"
import "../assets/css/Components.css"
import "../assets/css/App.css"
import "../assets/css/Pages.css"
import "../assets/css/Auth.css"
import "../assets/css/Admin.css"
import "../assets/css/CashRegister.css"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {useNavigate} from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import {ToastContainer} from "react-toastify";
import IntroSlides from "./IntroSlides";
import Footer from "./Footer";
import {Images} from "../constants/Images";
import {MdOutlineArrowBackIosNew} from "react-icons/md";
import axios from "axios";
import opsToast from "../ops-library/ops-toast";
import {ACCESS_TOKEN_KEY} from "../constants/constants";
import {LoadingSpinner} from "./LoadingSpinner";
import {isTokenExpired} from "../functions/isTokenExpired";
import CustomHeader from "./CustomHeader";

const AppContainer = ({
                          content,
                          showSlides,
                          showNavbar = true,
                          showFooter = true,
                      }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [logged, setLogged] = useState();
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") != null
            ? localStorage.getItem("theme")
            : "light"
    );

    useEffect(() => {
        if (!isTokenExpired(token)) {
            getLoggedUser();
        } else {
            setLogged(null);
        }
    }, []);

    function getLoggedUser() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/auth/profile`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                const user_id = result.data.user_id
                const configuration2 = {
                    method: "get",
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/userInfo/${user_id}`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                };
                axios(configuration2)
                    .then((result) => {
                        setLogged(result.data.userInfo)
                    })
                    .catch((error) => {
                        console.log(error)
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                    });


            })
            .catch((error) => {
                console.log(error)
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }


    return (
        logged !== undefined ?
            <div className="app-container fa-flex-col" data-theme={theme}>
                <ScrollToTop
                    top={250}
                    smooth={true}
                    component={<MdOutlineArrowBackIosNew color='var(--color-1)' className="ops-icon-bg transform-top"/>}
                    className="bg-primary-3 phone-not-shown"
                />
                {showNavbar && <CustomHeader showSlides={showSlides} slides={[]} loggedUser={logged}/>}
                <div>
                    {content}
                </div>
                <ToastContainer/>
                {showFooter && <Footer/>}
            </div>
            :
            <div className="app-container fa-flex-col" data-theme={theme}>
                <LoadingSpinner/>
            </div>
    );
};

export default AppContainer;